import Button from '@mui/material/Button';
import Collapse, { collapseClasses } from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';

import styled from 'shared/utils/styled';

export const StyledIconButton = styled(IconButton)(() => ({
  padding: 6,
  background: 'transparent',
  color: 'rgb(34, 64, 96)',
}));

export const StyledCollapse = styled(Collapse)(({ theme }) => ({
  maxWidth: 350,
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    [`& .${collapseClasses.wrapperInner}`]: {
      width: '100%',
    },
  },
}));

export const StyledButton = styled(Button)(() => ({
  padding: '6px 15px',
  fontFamily: 'NeoSansStd',
  background: '#fff',
  borderRadius: 29,
  color: '#347AC4',
  fontWeight: 600,
}));

export const ToggleButton = styled(StyledButton)(() => ({
  color: 'rgb(34, 64, 96)',
  background: 'transparent',
}));

type BoxAccessories = Partial<{
  alignCenter: boolean;
}>;

export const StyledBox = styled('div', {
  shouldForwardProp: (prop) => prop !== 'loading',
})<BoxAccessories>(({ alignCenter, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 20,
  background: '#fff',
  borderLeft: '10px solid rgb(34, 64, 96)',
  borderRadius: 2,
  boxShadow: '0 5px 8px rgba(112,136,210,0.203)',
  ...(alignCenter && {
    minHeight: 300,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  [theme.breakpoints.down('sm')]: {
    padding: '10px 8px',
    borderLeftWidth: 4,
  },
}));

export const Label = styled('p')(() => ({
  margin: 0,
  marginBottom: '15px',
  fontSize: '16px',
  fontWeight: 400,
  color: '#224060',
}));
